import PropTypes from 'prop-types';
import Card from 'components/ui-components/Card';
import Title from 'components/ui-components/Title';

const CardTemplate = ({ icon, title, description, children, link }) => (
  <div className="margin-center l-width-60">
    <Title icon={icon} title={title} description={description} link={link} />

    <Card className="mt-20" variant="large">
      {children}
    </Card>
  </div>
);

CardTemplate.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  link: PropTypes.shape({ url: PropTypes.string, title: PropTypes.string }),
};

export default CardTemplate;
